/* assets/lp-init-v2.js
 * Vanilla-JS rewrite of lp-init.js — no jQuery / Bootstrap JS / Flickity dependency.
 * Requires: lp-vanilla-modal.js (loaded before this file)
 */
(function () {
    "use strict";
  
    function onReady(fn) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", fn);
      } else {
        fn();
      }
    }
  
    function injectCSS(href) {
      if (document.querySelector("link[href='" + href + "']")) return;
      var l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      document.head.appendChild(l);
    }
  
    function injectJS(src, opts) {
      opts = opts || {};
      if (document.querySelector("script[src='" + src + "']")) {
        if (opts.onload) opts.onload();
        return;
      }
      var s = document.createElement("script");
      s.src = src;
      if (opts.async) s.async = true;
      if (opts.defer !== false) s.defer = true;
      if (opts.onload) s.onload = opts.onload;
      if (opts.onerror) s.onerror = opts.onerror;
      document.head.appendChild(s);
    }
  
    // -------------------------------------------------------
    // 1) Accordion — pure vanilla JS (replaces jQuery slideToggle)
    // -------------------------------------------------------
    function initAccordion() {
      var toggles = document.querySelectorAll(".accordion-toggle");
      if (!toggles.length) return;
  
      toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          var item = toggle.closest(".question-item");
          if (!item) return;
  
          var content = item.querySelector(".accordion-content");
          var icon = item.querySelector(".icon-accordion");
  
          if (!content) return;
  
          // slideToggle replacement
          if (content.style.display === "none" || !content.style.display || getComputedStyle(content).display === "none") {
            content.style.display = "block";
            content.style.overflow = "hidden";
            var h = content.scrollHeight;
            content.style.maxHeight = "0px";
            content.style.transition = "max-height 0.25s ease";
            content.offsetHeight; // reflow
            content.style.maxHeight = h + "px";
            content.addEventListener("transitionend", function onEnd() {
              content.removeEventListener("transitionend", onEnd);
              content.style.maxHeight = "";
              content.style.overflow = "";
              content.style.transition = "";
            });
          } else {
            content.style.overflow = "hidden";
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.transition = "max-height 0.25s ease";
            content.offsetHeight; // reflow
            content.style.maxHeight = "0px";
            content.addEventListener("transitionend", function onEnd() {
              content.removeEventListener("transitionend", onEnd);
              content.style.display = "none";
              content.style.maxHeight = "";
              content.style.overflow = "";
              content.style.transition = "";
            });
          }
  
          if (icon) icon.classList.toggle("open");
        });
      });
    }
  
    // -------------------------------------------------------
    // 3) Lazy-load Judge.me (only when reviews near viewport)
    //    The <template id="judgeme_tpl"> contains {% render 'judgeme_core' %}
    //    plus the widget div. We clone it into the mount point and rehydrate
    //    any <script>/<link> tags so Judge.me's core JS boots up.
    // -------------------------------------------------------
    function initLazyLoadJudgeMe() {
      var reviewsSection = document.querySelector("[data-lazy-judgeme='1']");
      if (!reviewsSection) return;
  
      var loaded = false;
  
      function rehydrateJudgemeScripts(container) {
        // Activate <script> tags that were cloned from <template>
        var scripts = Array.prototype.slice.call(container.querySelectorAll("script"));
        scripts.forEach(function (oldScript) {
          var s = document.createElement("script");
          for (var i = 0; i < oldScript.attributes.length; i++) {
            var attr = oldScript.attributes[i];
            s.setAttribute(attr.name, attr.value);
          }
          if (!s.src) {
            s.text = oldScript.textContent || "";
          }
          oldScript.parentNode.replaceChild(s, oldScript);
        });
  
        // Activate <link rel="stylesheet"> tags
        var links = Array.prototype.slice.call(container.querySelectorAll('link[rel="stylesheet"]'));
        links.forEach(function (oldLink) {
          var l = document.createElement("link");
          l.rel = "stylesheet";
          l.href = oldLink.href;
          if (oldLink.media) l.media = oldLink.media;
          document.head.appendChild(l);
          oldLink.parentNode.removeChild(oldLink);
        });
      }
  
      function loadJudgeMe() {
        if (loaded) return;
        loaded = true;
  
        var tpl = document.querySelector("#judgeme_tpl");
        var mount = document.querySelector("#judgeme_mount");
        if (tpl && mount && mount.childNodes.length === 0) {
          mount.appendChild(tpl.content.cloneNode(true));
          rehydrateJudgemeScripts(mount);
        }
  
        // Poll for jdgm to render widgets after core JS loads
        var tries = 0;
        (function kick() {
          tries++;
          if (window.jdgm && typeof window.jdgm.renderWidgets === "function") {
            window.jdgm.renderWidgets();
            return;
          }
          if (tries < 50) setTimeout(kick, 150);
        })();
      }
  
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            loadJudgeMe();
            io.disconnect();
          }
        }, { rootMargin: "300px 0px" });
        io.observe(reviewsSection);
      } else {
        window.addEventListener("scroll", function onScroll() {
          var rect = reviewsSection.getBoundingClientRect();
          if (rect.top < window.innerHeight + 300) {
            window.removeEventListener("scroll", onScroll);
            loadJudgeMe();
          }
        }, { passive: true });
      }
    }
  
    // -------------------------------------------------------
    // 4) Lazy-load Google Maps Places ONLY when modal opens
    // -------------------------------------------------------
    var __gmapsLoading = false;
  
    function ensureGooglePlacesLoaded(onDone) {
      if (window.google && google.maps && google.maps.places) {
        onDone && onDone();
        return;
      }
  
      if (__gmapsLoading) {
        var tries = 0;
        (function wait() {
          tries++;
          if (window.google && google.maps && google.maps.places) {
            onDone && onDone();
            return;
          }
          if (tries < 50) return setTimeout(wait, 100);
        })();
        return;
      }
  
      __gmapsLoading = true;
  
      var key = window.__LP_GMAPS_KEY;
      // Use loading=async (stable weekly channel) — matches the URL the legacy
      // eager <script> tag used. v=beta deprecates google.maps.places.Autocomplete
      // in favour of the new PlaceAutocompleteElement, which the form snippet
      // does NOT use, so the beta channel breaks address autocomplete.
      var src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(key || "") +
        "&libraries=places&loading=async";
  
      injectJS(src, {
        async: true,
        defer: false,
        onload: function () {
          __gmapsLoading = false;
          onDone && onDone();
        },
        onerror: function () {
          __gmapsLoading = false;
          console.warn("Google Maps failed to load");
        }
      });
    }
  
    // -------------------------------------------------------
    // 4.5) Mount sample form modal HTML on demand
    // -------------------------------------------------------
    function mountSampleFormModalIfNeeded() {
      var mount = document.getElementById("lp-modal-mount");
  
      // Form is rendered directly in the DOM (not via <template> cloning).
      // If #lp-modal-mount has content and #modal-new-form exists, it's ready.
      if (mount && mount.childNodes && mount.childNodes.length > 0) {
        if (typeof window.__lpBindModalListeners === "function") {
          window.__lpBindModalListeners();
        }
        return Promise.resolve(true);
      }
  
      // Fallback: try the old <template> approach if it exists
      var tpl = document.getElementById("lp-modal-template");
      if (!mount || !tpl) return Promise.resolve(false);
  
      mount.appendChild(tpl.content.cloneNode(true));
  
      if (typeof window.__lpBindModalListeners === "function") {
        window.__lpBindModalListeners();
      }
  
      return rehydrateScripts(mount).then(function () {
        return true;
      });
    }
  
    function initAutocompleteWhenReady() {
      var tries = 0;
  
      (function tick() {
        tries++;
  
        var input = document.getElementById("address-search");
        var app = window.appMount;
  
        // Skip if the inline form script already bound autocomplete
        if (input && input.classList.contains("pac-target-input")) {
          return;
        }
  
        if (
          window.google &&
          google.maps &&
          google.maps.places &&
          input &&
          app &&
          typeof app.getAutoCompleteChangesGoogle === "function"
        ) {
          try {
            var ac = new google.maps.places.Autocomplete(input, {
              componentRestrictions: { country: ["ca", "us"] },
              fields: ["address_components", "formatted_address"],
              types: ["address"]
            });
  
            ac.addListener("place_changed", function () {
              var place = ac.getPlace();
              app.getAutoCompleteChangesGoogle(place);
            });
  
            input.addEventListener("keydown", function (e) {
              if (e.key === "Enter") e.preventDefault();
            });
  
            return;
          } catch (e) {
            // fall through and retry
          }
        }
  
        if (tries < 80) return setTimeout(tick, 100);
      })();
    }
  
    function rehydrateScripts(container) {
      var scripts = Array.prototype.slice.call(container.querySelectorAll("script"));
      var chain = Promise.resolve();
  
      scripts.forEach(function (oldScript) {
        chain = chain.then(function () {
          var src = (oldScript.getAttribute("src") || "").toLowerCase();
          var code = (oldScript.textContent || "").toLowerCase();
  
          // Skip the external Google Maps API loader — we lazy-load it via
          // ensureGooglePlacesLoaded() instead.  Do NOT skip inline scripts
          // that *use* google.maps.places (e.g. the autocomplete init) —
          // those must still execute after mount.
          if (src.indexOf("maps.googleapis.com/maps/api/js") !== -1) {
            oldScript.parentNode && oldScript.parentNode.removeChild(oldScript);
            return Promise.resolve();
          }
  
          return new Promise(function (resolve) {
            var s = document.createElement("script");
  
            for (var i = 0; i < oldScript.attributes.length; i++) {
              var attr = oldScript.attributes[i];
              s.setAttribute(attr.name, attr.value);
            }
  
            if (s.src) {
              s.onload = function () { resolve(); };
              s.onerror = function () { resolve(); };
              document.head.appendChild(s);
            } else {
              s.text = oldScript.textContent || "";
              document.head.appendChild(s);
              resolve();
            }
  
            oldScript.parentNode && oldScript.parentNode.removeChild(oldScript);
          });
        });
      });
  
      return chain;
    }
  
    // -------------------------------------------------------
    // 5) Modal helpers — uses lpModal (vanilla) instead of Bootstrap
    // -------------------------------------------------------
    function exposeGlobalModalHelpers() {
      window.featuredProductButton = function featuredProductButton() {
        // Feature removed — no-op
      };
  
      window.openModal = function openModal() {
        var safeAccessRaw = sessionStorage.getItem("safeAccess");
        var safeAccess = safeAccessRaw ? JSON.parse(safeAccessRaw) : null;
  
        if (safeAccess === false) {
          window.location.assign("/products/sample-kit");
          return;
        }
  
        /* Landing Page F: index-landing-page-f.liquid sets window.LP_HAS_BUY_BOX
           when metaobject buy_box has a product — CTAs should land on #lp-buy-box
           instead of opening the sample modal. */
        if (window.LP_HAS_BUY_BOX === true) {
          var buyBox = document.getElementById("lp-buy-box");
          if (buyBox) {
            try {
              buyBox.focus({ preventScroll: true });
            } catch (e) {
              buyBox.focus();
            }
            buyBox.scrollIntoView({ behavior: "smooth", block: "start" });
            return;
          }
        }
  
        var sticky = document.querySelector("#page-content .lp-sticky-cta");
        if (sticky) sticky.classList.add("is-modal-open");
  
        mountSampleFormModalIfNeeded().then(function (mounted) {
          if (!mounted) return;
  
          var modalEl = document.getElementById("modal-new-form");
          if (!modalEl) return;
  
          // Use vanilla modal system
          window.lpModal.show(modalEl, { backdrop: "static", keyboard: false });
  
          ensureGooglePlacesLoaded(function () {
            initAutocompleteWhenReady();
          });
        });
      };
    }
  
    // -------------------------------------------------------
    // 6) Sticky CTA show/hide on mobile — vanilla JS
    // -------------------------------------------------------
    function initStickyMobileHowItWorks() {
      var isMobile =
        window.matchMedia && window.matchMedia("(max-width: 767.98px)").matches;
      if (!isMobile) return;
  
      var sticky = document.querySelector("#page-content .lp-sticky-cta");
      var howItWorks = document.querySelector("#page-content .how-it-works");
      if (!sticky || !howItWorks) return;
  
      var hasReachedHowItWorks = false;
      var isModalOpen = false;
  
      function updateSticky() {
        if (hasReachedHowItWorks && !isModalOpen) sticky.classList.add("is-visible");
        else sticky.classList.remove("is-visible");
        sticky.classList.toggle("is-modal-open", isModalOpen);
      }
  
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (entry && entry.isIntersecting) {
              hasReachedHowItWorks = true;
              updateSticky();
              io.disconnect();
            }
          },
          { threshold: 0.01, rootMargin: "0px 0px -35% 0px" }
        );
        io.observe(howItWorks);
      } else {
        var onScroll = function () {
          var top = howItWorks.getBoundingClientRect().top + window.scrollY;
          if (window.scrollY + window.innerHeight >= top + 40) {
            hasReachedHowItWorks = true;
            updateSticky();
            window.removeEventListener("scroll", onScroll);
          }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
      }
  
      // Listen for modal show/hide events (dispatched by lp-vanilla-modal.js)
      function bindModalListeners() {
        var modals = document.querySelectorAll("#page-content .modal");
        if (!modals.length) return;
  
        modals.forEach(function (modal) {
          modal.addEventListener("show.bs.modal", function () {
            isModalOpen = true;
            updateSticky();
          });
  
          modal.addEventListener("hidden.bs.modal", function () {
            // Check if any modal still has .show
            isModalOpen = document.querySelectorAll(".modal.show").length > 0;
            updateSticky();
          });
        });
      }
  
      bindModalListeners();
      window.__lpBindModalListeners = bindModalListeners;
  
      updateSticky();
    }
  
    // -------------------------------------------------------
    // 7) How It Works — mobile carousel dot sync
    // -------------------------------------------------------
    function initStepsCarouselDots() {
      var viewport = document.querySelector(".how-it-works .steps-viewport");
      var wrapper = document.querySelector(".how-it-works .steps-wrapper");
      var dots = document.querySelectorAll(".steps-dots .steps-dot");
      var items = wrapper ? wrapper.querySelectorAll(".step-item") : [];
      if (!viewport || !wrapper || !dots.length || !items.length) return;
  
      // Only run on mobile
      var isMobile = window.matchMedia && window.matchMedia("(max-width: 700px)").matches;
      if (!isMobile) return;
  
      var current = 0;
      var total = items.length;
      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var dragging = false;
      var isHorizontal = null;
  
      // Get the left offset of card N relative to the wrapper
      function getCardOffset(idx) {
        if (!items[idx]) return 0;
        return items[idx].offsetLeft;
      }
  
      function getCardWidth() {
        return items[0].offsetWidth;
      }
  
      function goTo(idx, animate) {
        idx = Math.max(0, Math.min(idx, total - 1));
        current = idx;
        var offset = -getCardOffset(idx);
        if (animate !== false) {
          wrapper.classList.add("is-animating");
        } else {
          wrapper.classList.remove("is-animating");
        }
        wrapper.style.transform = "translateX(" + offset + "px)";
        dots.forEach(function (d, i) {
          d.classList.toggle("active", i === current);
        });
      }
  
      // Wait for section to be visible before setting initial position
      if ("IntersectionObserver" in window) {
        var initObs = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            goTo(0, false);
            initObs.disconnect();
          }
        }, { threshold: 0 });
        initObs.observe(viewport);
      }
      // Also set immediately in case section is already in view
      goTo(0, false);
  
      // Touch events on the viewport container
      viewport.addEventListener("touchstart", function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        deltaX = 0;
        dragging = true;
        isHorizontal = null;
        wrapper.classList.remove("is-animating");
      }, { passive: true });
  
      viewport.addEventListener("touchmove", function (e) {
        if (!dragging) return;
  
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
  
        // Lock direction after 10px of movement
        if (isHorizontal === null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
          isHorizontal = Math.abs(dx) > Math.abs(dy);
        }
  
        if (isHorizontal === false) {
          dragging = false;
          return;
        }
  
        if (isHorizontal) {
          e.preventDefault();
          deltaX = dx;
          var base = -getCardOffset(current);
          wrapper.style.transform = "translateX(" + (base + deltaX) + "px)";
        }
      }, { passive: false });
  
      viewport.addEventListener("touchend", function () {
        if (!dragging || !isHorizontal) {
          dragging = false;
          return;
        }
        dragging = false;
        var threshold = getCardWidth() * 0.2;
        if (deltaX < -threshold && current < total - 1) {
          goTo(current + 1);
        } else if (deltaX > threshold && current > 0) {
          goTo(current - 1);
        } else {
          goTo(current);
        }
      }, { passive: true });
  
      // Click dot to go to that step
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          var idx = parseInt(dot.getAttribute("data-dot"), 10);
          goTo(idx);
        });
      });
    }
  
    // -------------------------------------------------------
    // Boot
    // -------------------------------------------------------
    onReady(function () {
      initAccordion();
      exposeGlobalModalHelpers();
      initStickyMobileHowItWorks();
      initLazyLoadJudgeMe();
      initStepsCarouselDots();
    });
  })();
  
  